/**
 * @Description 周边配套
 */
import useUpdateEffect from '@/common/hook/updateEffect/useUpdateEffect';
import { FC, useRef } from 'react';
import { Typography } from 'antd';
import styles from '../index.module.less';
import { showMarker } from '@/common/utils/map';
import IconFont from '@/common/components/IconFont';
import { targetLegendIcon } from '../../../ts-config';
import { mapContainer } from '..';
import { bigdataAction } from '@/common/utils/bigdata';
const { Paragraph } = Typography;

const CommonRimMarker:FC<any> = ({
  mapIns,
  data,
  contentMarkerRef,
  curDetail,
  setCurDetail,
  handleDetailToNull,
  onClickMarker = () => {}
}) => {
  const massListRef = useRef<any>([]);
  const activeMarker = useRef<any>(null);
  const activePolygon = useRef<any>(null);
  const createContentMarker = (value, tag, activeMarker = null) => {
    const dom = document.querySelector(`.${mapContainer}`);
    var pixel = mapIns.lngLatToContainer([value?.lng, value?.lat]);
    const { x, y } = pixel;
    const offset = [0, 0];
    let topBottom = 'top';
    let leftRight = 'center';
    if (y < 200) {
      topBottom = 'top';
    } else if ((dom?.clientHeight || 0) - y < 200) {
      topBottom = 'bottom';
      offset[1] = 0;
    }
    if (x < 200) {
      leftRight = 'left';
    } else if ((dom?.clientWidth || 0) - x < 200) {
      leftRight = 'right';
    }

    contentMarkerRef.current && mapIns.remove(contentMarkerRef.current);
    contentMarkerRef.current = new window.AMap.Marker({
      position: [value.lng, value.lat],
      anchor: `${topBottom}-${leftRight}`,
      offset,
      zIndex: 60,
      extData: {
        tag
      }
    });
    mapIns.add(contentMarkerRef.current);
    onClickMarker?.();
    showMarker(contentMarkerRef.current,
      <TargetBrand
        data={value}
        mapIns={mapIns}
        marker={contentMarkerRef.current}
        activeMarker={activeMarker}
        handleDetailToNull={() => {
          activePolygon.current && mapIns.remove(activePolygon.current);
          handleDetailToNull();
        }}
        tag={tag}
      />);
  };
  const createMass = (data, key) => {
    const value = data.map((item) => ({
      lnglat: [+item.lng, +item.lat],
      detail: item,
      ...item,
    }));

    var mass = new window.AMap.MassMarks(value, {
      opacity: 1,
      cursor: 'pointer',
      style: {
        url: `${targetLegendIcon?.[key]}`,
        size: [24, 29],
        anchor: 'bottom-center'
      },
      zooms: [1, 20],
      zIndex: 500, // 不然会被showIndoorMap遮挡
    });
    mass.setMap(mapIns);

    mass.on('click', ({ data }) => {
      handleDetailToNull();
      setCurDetail(data);
      // 动态改变 Marker 的图标和尺寸
      activeMarker.current && mapIns.remove(activeMarker.current);
      createActiveMarker(data, key);
      createActivePolygonMarker(data);
      // /spotevaluation/history?modelConfigId=23 查询例如跳转页未配置菜单，写死op_feat，op_menu
      bigdataAction('c0c5c3c9-3fba-43cb-89d9-9cdcdb87f650', 'spotEvaluation',
        '点位测评', '详情页-地图图标', '点击了详情页-地图图标', { op_block: '', op_event: '', });
    });
    massListRef.current.push(mass);
  };
  const createActiveMarker = (value, key) => {
    const marker = new window.AMap.Marker({
      position: [value.lng, value.lat],
      content: `<img class="storeMarkerActive" src="${targetLegendIcon?.[key]}"/>`,
      anchor: 'bottom-center',
      extData: value
    });
    activeMarker.current && mapIns.remove(activeMarker.current);
    activeMarker.current = marker;
    createContentMarker(value, key, marker);
    mapIns.add(marker);
  };
  const createActivePolygonMarker = (value) => {
    activePolygon.current && mapIns.remove(activePolygon.current);
    if (!value?.polygonList?.length) return;
    const { polygonList } = value;
    const polygonMarker = new window.AMap.Polygon({
      path: polygonList.map((item: any) => [+item?.lng, +item?.lat]),
      fillColor: '#006AFF',
      strokeOpacity: 1,
      fillOpacity: 0.2,
      strokeColor: '#4792FD',
      strokeWeight: 2,
    });
    activePolygon.current = polygonMarker;
    mapIns.add(polygonMarker);
  };
  const clearMarker = () => {
    massListRef.current?.map((mass) => {
      mass?.clear();
    });
    massListRef.current = [];
    activeMarker.current && mapIns?.remove(activeMarker.current);
    activePolygon.current && mapIns.remove(activePolygon.current);
  };
  useUpdateEffect(() => {
    if (!mapIns) return;
    clearMarker();
    Object.keys(data)?.map((item) => {
      createMass(data[item], item);
      // data[item].map((value) => {
      //   createMarker(value, item);
      // });
    });
  }, [mapIns, data]);

  useUpdateEffect(() => {
    let curValue;
    activeMarker.current && mapIns.remove(activeMarker.current);
    activePolygon.current && mapIns.remove(activePolygon.current);
    Object.keys(data).reduce((acc, key) => {
      if (acc) return acc;
      data[key].map((item) => {
        if (item.lng === curDetail?.lng && item.lat === curDetail?.lat) {
          acc = true;
          curValue = {
            ...item,
            tag: key
          };
        };
      });
      return acc;
    }, false);

    if (curValue) {
      createContentMarker(curValue, curValue.tag);
      createActiveMarker(curValue, curValue.tag);
      createActivePolygonMarker(curValue);
    }
  }, [curDetail]);

  useUpdateEffect(() => {
    const tag = contentMarkerRef.current?.getExtData()?.tag;
    if (tag && !data[tag]?.length) {
      contentMarkerRef.current && mapIns?.remove(contentMarkerRef.current);
    }
  }, [data]);

  return <div>

  </div>;
};

const TargetBrand = ({
  data,
  mapIns,
  marker,
  activeMarker,
  handleDetailToNull,
  tag
}) => {
  const showText = tag === 'ZHU_ZHAI'; // 小区类型展示房价等字段
  return <div className={styles.competitorOverview}>
    <IconFont
      iconHref={'iconic_close_colour_seven'}
      className={styles.closeIcon}
      onClick={() => {
        handleDetailToNull();
        mapIns.remove(marker);
        mapIns.remove(activeMarker);
      }}
    />
    {/* <div className='fs-14 bold pr-16'>{data?.name}</div> */}
    <Paragraph
      style={{ width: 170, marginBottom: 0 }}
      ellipsis={{
        tooltip: data?.name,
        rows: 2,
      }}>
      <span className='fs-14 bold pr-16'>
        {data?.name}
      </span>
    </Paragraph>
    {showText
      ? <div className={styles.poiInfo}>
        {data.housePrice
          ? <div className={styles.poiLabel}>参考房价
            <span className={styles.poiValue}>{data.housePrice}</span>
          </div> : ''}
        {data.liveNum ? <div className={styles.poiLabel}>居住人口
          <span className={styles.poiValue}>{data.liveNum || '-'}</span>
        </div> : ''}
        {data.buildTime
          ? <div className={styles.poiLabel}>建造时间
            <span className={styles.poiValue}>{data.buildTime}</span>
          </div> : ''}
        {
          data?.address ? <div className={styles.poiLabel}>地址
            <span className={styles.poiValue}>{data.address}</span>
          </div> : <></>
        }
      </div> : <>
        {
          data?.address ? <div className='c-999 fs-12 mt-6'>
            {data?.address}
          </div> : <></>
        }
      </>}
  </div>;
};
export default CommonRimMarker;
